<script lang="ts" setup>
import { resolveIcon } from './resolveIcon';

defineOptions({
    inheritAttrs: false
});

const props = withDefaults(defineProps<{
    name?: string | null;
    size?: number | string;
    strokeWidth?: number | string;
}>(), {
    name: null,
    size: 16,
    strokeWidth: 1.8
});

const attrs = useAttrs();
const element = ref<any>(null);

const iconAttrs = computed(() =>
{
    const result = { ...attrs };

    delete result.title;

    return result;
});

const tooltip = computed(() => typeof attrs.title === 'string' && attrs.title.length > 0 ? attrs.title : null);
const tooltipTarget = computed(() => element.value?.$el ?? element.value);
const accessibleLabel = computed(() => attrs['aria-label'] ?? tooltip.value ?? undefined);

const iconClasses = computed(() =>
{
    const tokens = props.name?.trim().split(/\s+/).filter(Boolean) || [];

    return tokens.slice(1);
});

const icon = computed(() => resolveIcon(props.name));
</script>

<template>
    <component
        :is="icon"
        ref="element"
        :size="size"
        :stroke-width="strokeWidth"
        :class="iconClasses"
        v-bind="iconAttrs"
        :aria-label="accessibleLabel"
        :aria-hidden="accessibleLabel ? undefined : 'true'"
    />
    <IdeoTooltip v-if="tooltip" external :target="tooltipTarget" :tooltip="tooltip" />
</template>
